var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8722 0.166504H9.14474C3.77724 0.166504 0.167236 3.93484 0.167236 9.53984V22.4757C0.167236 28.0648 3.77724 31.8332 9.14474 31.8332H22.8722C28.2397 31.8332 31.8339 28.0648 31.8339 22.4757V9.53984C31.8339 3.93484 28.2397 0.166504 22.8722 0.166504Z",
    fill: "#fb4646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1212 21.1426C13.7666 21.1426 13.4119 21.008 13.1412 20.7372L9.38391 16.98C8.84241 16.4385 8.84241 15.5613 9.38391 15.0214C9.92541 14.4799 10.801 14.4783 11.3425 15.0198L14.1212 17.7986L20.6572 11.2626C21.1987 10.7211 22.0743 10.7211 22.6158 11.2626C23.1573 11.8041 23.1573 12.6812 22.6158 13.2227L15.1013 20.7372C14.8306 21.008 14.4759 21.1426 14.1212 21.1426Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTick);
export default __webpack_public_path__ + "static/media/blueTick.85fa2dd1.svg";
export { ForwardRef as ReactComponent };